import dompurify from 'dompurify';

angular.module('shared').directive('domPurify', function() {
  return {
    require: 'ngModel',
    link: function(scope, element, attrs, ngModel) {
      return ngModel.$formatters.push(function(viewValue) {
        return dompurify.sanitize(viewValue, {
          ADD_ATTR: ['target', 'alt', 'data-asset-id']
        });
      });
    }
  };
});
